// /home/clement/compta-app/client/src/components/Facturation/Vente/ListeFacturesVente.js

import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { fetchFacturesVente } from '../../../api/factureVenteApi';

const ListeFacturesVente = () => {
  const [factures, setFactures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Récupération des factures de vente depuis l'API
  useEffect(() => {
    const loadFacturesVente = async () => {
      try {
        const data = await fetchFacturesVente();
        setFactures(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadFacturesVente();
  }, []);

  // Définition des colonnes pour le DataGrid
  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    {
      field: 'date',
      headerName: 'Date',
      width: 120,
      valueFormatter: (params) => new Date(params.value).toLocaleDateString(),
    },
    { field: 'client', headerName: 'Client', width: 200 },
    { field: 'montantTTC', headerName: 'Montant TTC (€)', width: 150 },
    { field: 'statut', headerName: 'Statut', width: 120 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <Button
          variant="outlined"
          size="small"
          component={Link}
          to={`/factures-vente/${params.row.id}`}
        >
          Détails
        </Button>
      ),
    },
  ];

  if (loading) return <div>Chargement des factures...</div>;
  if (error) return <div>Erreur : {error}</div>;

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <Typography variant="h4" gutterBottom>
        Liste des factures de vente
      </Typography>
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="/factures-vente/ajouter"
        sx={{ mb: 2 }}
      >
        Ajouter une facture
      </Button>
      <DataGrid
        rows={factures}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10, 20]}
        autoHeight
      />
    </Box>
  );
};

export default ListeFacturesVente;

